// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-wrap[data-v-34965af0]{overflow:visible;text-overflow:unset;white-space:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
